module.exports = __webpack_public_path__ + "static/f022ed2af21de963531778495936915abee902efe5f0e3dfc5fc65583677a16a-03dc9f6857ec46444d2f92f6ed2daf0f.png";